import React from 'react';

import { Tr } from '@chakra-ui/react';

import CompositionGroupTable from './CompositionGroupTable';
import { formatCurrency } from './formatters';
import { StyledTd, StyledTh } from './StyledTableCell';

export type LaborGroupRow = {
  code: string;
  description: string;
  quantity: number;
  unit: string;
  hourlyCost: number;
  totalHourlyCost: number;
};

type LaborGroupTableProps = {
  data: LaborGroupRow[];
};

const LaborGroupTable: React.FC<LaborGroupTableProps> = ({ data }) => {
  const totalLaborHourlyCost = data.reduce(
    (total, item) => total + item.totalHourlyCost,
    0,
  );

  const totalExecutionHourlyCost = 569.22;
  const executionUnitCost = 10805.31;
  const rainInfluenceFactor = 0;

  return (
    <CompositionGroupTable
      headerRows={
        <Tr>
          <StyledTh colSpan={2}>B - MÃO DE OBRA</StyledTh>
          <StyledTh textAlign="center" width="90px">
            Quantidade
          </StyledTh>
          <StyledTh textAlign="center" width="90px">
            Unidade
          </StyledTh>
          <StyledTh textAlign="right" width="140px">
            Custo Horário
          </StyledTh>
          <StyledTh textAlign="right" width="160px">
            Custo Horário Total
          </StyledTh>
        </Tr>
      }
      bodyRows={
        <>
          {data.map((item) => (
            <Tr key={item.code}>
              <StyledTd width="1%" minWidth="50px" whiteSpace="nowrap">
                {item.code}
              </StyledTd>
              <StyledTd
                minWidth="220px"
                whiteSpace="normal"
                overflowWrap="break-word"
                wordBreak="break-word"
                width="auto"
              >
                {item.description}
              </StyledTd>
              <StyledTd textAlign="center">{item.quantity}</StyledTd>
              <StyledTd textAlign="center">{item.unit}</StyledTd>
              <StyledTd textAlign="right">
                {formatCurrency(item.hourlyCost)}
              </StyledTd>
              <StyledTd textAlign="right">
                {formatCurrency(item.totalHourlyCost)}
              </StyledTd>
            </Tr>
          ))}

          <Tr>
            <StyledTd colSpan={5} textAlign="right" fontWeight="600">
              Custo horário total de mão de obra
            </StyledTd>
            <StyledTd textAlign="right" fontWeight="600">
              {formatCurrency(totalLaborHourlyCost)}
            </StyledTd>
          </Tr>
          <Tr>
            <StyledTd colSpan={5} textAlign="right" fontWeight="600">
              Custo horário total de execução
            </StyledTd>
            <StyledTd textAlign="right" fontWeight="600">
              {formatCurrency(totalExecutionHourlyCost)}
            </StyledTd>
          </Tr>
          <Tr>
            <StyledTd colSpan={5} textAlign="right" fontWeight="600">
              Custo Unitário de Execução
            </StyledTd>
            <StyledTd textAlign="right" fontWeight="600">
              {formatCurrency(executionUnitCost)}
            </StyledTd>
          </Tr>
          <Tr>
            <StyledTd colSpan={5} textAlign="right" fontWeight="600">
              Fator de Influencia da Chuva - FIC
            </StyledTd>
            <StyledTd textAlign="right" fontWeight="600">
              {rainInfluenceFactor}
            </StyledTd>
          </Tr>
        </>
      }
    />
  );
};

export default LaborGroupTable;
